import { render, staticRenderFns } from "./AllServicePartnersDeleted.vue?vue&type=template&id=5187b1bc&scoped=true"
import script from "./AllServicePartnersDeleted.vue?vue&type=script&lang=js"
export * from "./AllServicePartnersDeleted.vue?vue&type=script&lang=js"
import style0 from "./AllServicePartnersDeleted.vue?vue&type=style&index=0&id=5187b1bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5187b1bc",
  null
  
)

export default component.exports